export const costCenter = [
    'it',
    'sn',
    'advertisement',
    'travel',
    'insurance',
    'team', 'banking',
    'office',
    'consulting',
    'freelance',
    'AI',
    'project',
    'other'
];

export const editorConfig = {
    toolbar: [],
    mention: {
        feeds: [
            {
                marker: '@',
                feed: [
                    '@Annie',
                    '@Antonio',
                    '@Catherine',
                    '@Coco',
                    '@Evgenia',
                    '@Fred',
                    '@Guiga',
                    '@John',
                    '@Joris',
                    '@Justin',
                    '@Kate',
                    '@Kevin',
                    '@Kristin',
                    '@Lilien',
                    '@Lizaveta',
                    '@Marvin',
                    '@Max',
                    '@Nia',
                    '@Nikita',
                    '@Olga',
                    '@Piotr',
                    '@Sabine',
                    '@Valeria',
                    '@Vik',
                    '@Wooin',
                    '@Yinon',
                    '@Christian'
                ],
                minimumCharacters: 0
            }
        ]
    }
};
